import { createCrewLookupSelect } from './createCrewLookupSelect';

export const ManningAgentSelect = createCrewLookupSelect('ManningAgentSelect', 'manningAgents');
export default ManningAgentSelect;
